var footerApp = angular.module('footerApp', ['sharedServices','configService','sharedFilters','searchData','ngCookies']);

footerApp.config(function($interpolateProvider,$httpProvider) {
    $interpolateProvider.startSymbol('{[');
    $interpolateProvider.endSymbol(']}');
    $httpProvider.interceptors.push('APIInterceptor');
});

footerApp.controller('footerController', ['$scope', '$http','$rootScope', '$location', '$window', '$timeout', 'logoutUser', 'getUserInfo', 'config', 'EncryptedLocalStorage', 'joinW', 'getSearchInfo','vendorDashboard','$cookies', function($scope, $http,$rootScope, $location, $window, $timeout, logoutUser, getUserInfo, config, EncryptedLocalStorage, joinW, getSearchInfo,vendorDashboard,$cookies) {

    $scope.content = "WedMeGood is your personal wedding planning site. Browse through the site to find vendors for your wedding. Explore wedding inspiration & ideas and our very popular wedding blog to prepare for your wedding following latest trends. Contact us for more details. ";

    $scope.S3_URL = config.S3_URL;

    $scope.showVenue = true;
    $scope.showPhotographers = false;
    $scope.showBridalMakeups = false;
    $scope.showBridalWear = false;
    $scope.showGroomWear = false;
    $scope.showTent = false;
    $scope.showInvitations = false;
    $scope.showFavour = false;
    $scope.currentCity = true;
    $scope.currentCityDelhi = false;
    $scope.currentCityMumbai = false;

    $scope.category = [

        {
        "id": "10",
        "category_name": "Venue",
        "category_order": "1",
        "category_alias": "Wedding Venues",
        "category_slug": "wedding-venues",
        "icon_url": $scope.S3_URL + "category_icons/10.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/10.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/Venue_1.jpg",
        "type": 1
        },
        {
        "id": "1",
        "category_name": "Photographers",
        "category_order": "2",
        "category_alias": "Wedding Photographers",
        "category_slug": "wedding-photographers",
        "icon_url": $scope.S3_URL + "category_icons/1.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/1.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/Photography_1.jpg",
        "type": 1
        },
        {
        "id": "3",
        "category_name": "Makeup Artist",
        "category_order": "3",
        "category_alias": "Bridal Makeup",
        "category_slug": "bridal-makeup",
        "icon_url": $scope.S3_URL + "category_icons/3.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/3.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/makeup.jpg",
        "type": 1
        },
        {
        "id": "4",
        "category_name": "Bridal Wear",
        "category_order": "4",
        "category_alias": "Bridal Wear",
        "category_slug": "bridal-wear",
        "icon_url": $scope.S3_URL + "category_icons/4.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/4.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/outfit.jpg",
        "type": 1
        },
        {
        "id": "5",
        "category_name": "Groom Wear",
        "category_order": "5",
        "category_alias": "Groom Wear",
        "category_slug": "groom-wear",
        "icon_url": $scope.S3_URL + "category_icons/5.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/5.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/groom.jpg",
        "type": 1
        },
        {
        "id": "6",
        "category_name": "Decor",
        "category_order": "6",
        "category_alias": "Wedding Decorators",
        "category_slug": "wedding-decorators",
        "icon_url": $scope.S3_URL + "category_icons/6.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/6.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/decor.jpg",
        "type": 1
        },
        {
        "id": "17",
        "category_name": "Wedding Planners",
        "category_order": "7",
        "category_alias": "Wedding Planner ",
        "category_slug": "planners",
        "icon_url": $scope.S3_URL + "category_icons/17.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/17.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/Planner_1.jpg",
        "type": 1
        },
        {
        "id": "8",
        "category_name": "Invitations",
        "category_order": "8",
        "category_alias": "Wedding Cards",
        "category_slug": "wedding-cards",
        "icon_url": $scope.S3_URL + "category_icons/8.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/8.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/invitation.jpg",
        "type": 1
        },
        {
        "id": "12",
        "category_name": "Cinema/Video",
        "category_order": "9",
        "category_alias": "Wedding Videography",
        "category_slug": "wedding-videography",
        "icon_url": $scope.S3_URL + "category_icons/12.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/12.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/Cinema_1.jpg",
        "type": 1
        },
        {
        "id": "13",
        "category_name": "Mehendi Artist",
        "category_order": "10",
        "category_alias": "Mehendi Artist",
        "category_slug": "mehendi-artists",
        "icon_url": $scope.S3_URL + "category_icons/13.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/13.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/mehendi_1.jpg",
        "type": 1
        },
        {
        "id": "9",
        "category_name": "Cake",
        "category_order": "12",
        "category_alias": "Wedding Cakes",
        "category_slug": "wedding-cakes",
        "icon_url": $scope.S3_URL + "category_icons/9.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/9.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/rustic-cake_1.jpg",
        "type": 1
        },
        {
        "id": "2",
        "category_name": "Jewellery",
        "category_order": "13",
        "category_alias": "Wedding Jewellery",
        "category_slug": "wedding-jewellery",
        "icon_url": $scope.S3_URL + "category_icons/2.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/2.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/jewellery.jpg",
        "type": 1
        },
        {
        "id": "7",
        "category_name": "Catering Services",
        "category_order": "14",
        "category_alias": "Wedding Catering",
        "category_slug": "wedding-catering",
        "icon_url": $scope.S3_URL + "category_icons/7.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/7.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/catering.jpg",
        "type": 1
        },
        {
        "id": "14",
        "category_name": "Trousseau Packers",
        "category_order": "15",
        "category_alias": "Trousseau Packers",
        "category_slug": "trousseau-packers",
        "icon_url": $scope.S3_URL + "category_icons/14.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/14.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/Trousseau_1.jpg",
        "type": 1
        },
        {
        "id": "19",
        "category_name": "DJs",
        "category_order": "16",
        "category_alias": "DJ",
        "category_slug": "djs",
        "icon_url": $scope.S3_URL + "category_icons/19.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/19.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/dj.jpg",
        "type": 1
        },
        {
        "id": "15",
        "category_name": "Choreographer",
        "category_order": "17",
        "category_alias": "Sangeet Choreographers",
        "category_slug": "sangeet-choreographers",
        "icon_url": $scope.S3_URL + "category_icons/15.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/15.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/Choreo_1.jpg",
        "type": 1
        },
        {
        "id": "18",
        "category_name": "Accessories",
        "category_order": "19",
        "category_alias": "Wedding Accessories",
        "category_slug": "wedding-accessories",
        "icon_url": $scope.S3_URL + "category_icons/18.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/18.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/shoes.jpg",
        "type": 1
        },
        {
        "id": "16",
        "category_name": "Favors",
        "category_order": "20",
        "category_alias": "Wedding Favors",
        "category_slug": "wedding-favors",
        "icon_url": $scope.S3_URL + "category_icons/16.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/16.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/favor.jpg",
        "type": 1
        },
        {
        "id": "101",
        "category_name": "Logistics",
        "category_order": "21",
        "category_alias": "Logistics",
        "category_slug": "logistics",
        "icon_url": $scope.S3_URL + "category_icons/101.png",
        "icon_url_white": $scope.S3_URL + "category_icons/white/101.png",
        "background_url": $scope.S3_URL + "uploads/vendor_types/images/mobile/category/logistics.png",
        "type": 2,
        "redirect_url": "https://www.wedmegood.com/uberweddings"
        }
    ];
    $scope.city = [
        {
        "id": "1",
        "name": "Delhi NCR",
        "slug": "delhi-ncr",
        "cityType_id": "1",
        "others": "0",
        "address_id": "1964",
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "6",
        "name": "Mumbai",
        "slug": "mumbai",
        "cityType_id": "1",
        "others": "0",
        "address_id": "3483",
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "9",
        "name": "Bangalore",
        "slug": "bangalore",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "11",
        "name": "Hyderabad",
        "slug": "hyderabad",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "7",
        "name": "Pune",
        "slug": "pune",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "10",
        "name": "Chennai",
        "slug": "chennai",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "16",
        "name": "Goa",
        "slug": "goa",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "17",
        "name": "Jaipur",
        "slug": "jaipur",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "12",
        "name": "Kolkata",
        "slug": "kolkata",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "15",
        "name": "Chandigarh",
        "slug": "chandigarh",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "14",
        "name": "Ahmedabad",
        "slug": "ahmedabad",
        "cityType_id": "1",
        "others": "0",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "18",
        "name": "USA",
        "slug": "usa",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "19",
        "name": "Ludhiana",
        "slug": "ludhiana",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "20",
        "name": "Srinagar",
        "slug": "kashmir",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "21",
        "name": "UK",
        "slug": "uk",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "22",
        "name": "Lucknow",
        "slug": "lucknow",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "23",
        "name": "Vadodara",
        "slug": "vadodara",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "24",
        "name": "HongKong",
        "slug": "hongkong",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "25",
        "name": "Dubai",
        "slug": "dubai",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "27",
        "name": "Patiala",
        "slug": "patiala",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "28",
        "name": "Surat",
        "slug": "surat",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "29",
        "name": "Raipur",
        "slug": "raipur",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "32",
        "name": "Arizona, USA",
        "slug": "arizona",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "34",
        "name": "Silvassa",
        "slug": "silvassa",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "35",
        "name": "Amritsar",
        "slug": "amritsar",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "36",
        "name": "Thailand",
        "slug": "thailand",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "38",
        "name": "Ranchi",
        "slug": "ranchi",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "39",
        "name": "Nagpur",
        "slug": "nagpur",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "41",
        "name": "Jalandhar",
        "slug": "jalandhar",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "44",
        "name": "Washington , USA",
        "slug": "washington",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "45",
        "name": "Jodhpur",
        "slug": "jodhpur",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "46",
        "name": "Udaipur",
        "slug": "udaipur",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "47",
        "name": "Madurai",
        "slug": "madurai",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "48",
        "name": "Ambala",
        "slug": "ambala",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "50",
        "name": "Bhopal",
        "slug": "bhopal",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "51",
        "name": "Indore",
        "slug": "indore",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "52",
        "name": "Australia",
        "slug": "australia",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "53",
        "name": "Netherlands",
        "slug": "netherlands",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "54",
        "name": "Canada",
        "slug": "canada",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "55",
        "name": "Singapore",
        "slug": "singapore",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "56",
        "name": "Kerala",
        "slug": "kerala",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "57",
        "name": "Pakistan",
        "slug": "pakistan",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "58",
        "name": "Alwar (Rajasthan)",
        "slug": "alwar",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "59",
        "name": "Shimla",
        "slug": "shimla",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "61",
        "name": "Italy",
        "slug": "italy",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "62",
        "name": "Indonesia",
        "slug": "indonesia",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "63",
        "name": "Mussoorie",
        "slug": "mussorie",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "64",
        "name": "Pushkar",
        "slug": "pushkar",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "65",
        "name": "Mauritius",
        "slug": "mauritius",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "66",
        "name": "Nashik",
        "slug": "nashik",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "67",
        "name": "Aurangabad",
        "slug": "aurangabad",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "68",
        "name": "Bhubaneswar",
        "slug": "bhubaneshwar",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "69",
        "name": "Varanasi",
        "slug": "varanasi",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "70",
        "name": "Lonavala",
        "slug": "lonavala",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "71",
        "name": "Agra",
        "slug": "agra",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "72",
        "name": "Guwahati",
        "slug": "guwahati",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "73",
        "name": "Mysore",
        "slug": "mysore",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "74",
        "name": "Siliguri",
        "slug": "siliguri",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "76",
        "name": "Visakhapatnam",
        "slug": "visakhapatnam",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "78",
        "name": "Jaisalmer",
        "slug": "jaisalmer",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "79",
        "name": "Dehradun",
        "slug": "dehradun",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "80",
        "name": "New Zealand",
        "slug": "new-zealand",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "1"
        },
        {
        "id": "81",
        "name": "Coimbatore",
        "slug": "coimbatore",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "82",
        "name": "South Africa",
        "slug": "south-africa",
        "cityType_id": "3",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        },
        {
        "id": "83",
        "name": "Mangalore",
        "slug": "magalore",
        "cityType_id": "2",
        "others": "1",
        "address_id": null,
        "vendor": "1",
        "isRealWedding": "0"
        }
    ];

    init();

    function getCity(str){

        var i;
        var len  = $scope.city.length;
        for( i = 0 ; i < len ; i++){
            var temp = $scope.city[i];
            if(temp.slug == str){
                return temp.name;
            }
        }
    }

    function getCategory(str){
        var i;
        var len  = $scope.category.length;
        for( i = 0 ; i < len ; i++){
            var temp = $scope.category[i];
            if(temp.category_slug == str){
                return temp.category_alias;
            }
        }
    }

    function CategoryContent(category){
        var cont = 'Find list of top '+category+' here at Wedmegood - Your personal wedding planner. Check their prices & reviews and select the '+category+' in your city / locality. See their photos & videos, check their availability, shortlist them, get contact details, send enquiry, get best quote directly from the vendor and get best deals (up to 30% off) through WedMeGood for selected '+category+'.';

        if(category == "Wedding Photographers"){
            cont = "Whether it is for a pre wedding shoot, the most beautiful bridal photos or magical candid wedding photography, finding a wedding photographer that fits your bill as well as your style can be daunting.  WedMeGood has a list of top wedding photographers for you to choose for your indian wedding or engagement.  Pick from the best photograhers for traditional photography, couple photo shoots as well as those that create stunning wedding pictures, filter by price and your city and make an informed choice by reading their reviews. Your engagement pictures and marriage photos need to be preserved, so ensure you pick a professional photographer instead of an amateur.";
        }
        if(category == "Bridal Makeup"){
            cont = "Bridal makeup is perhaps the most important decision for an Indian bride. The right bridal makeup artist will give you options for great wedding hairstyles, be able to customise a pre bridal package and advise you on the best bridal makeup styles that will look great in pictures. WedMeGood has a list of the best makeup artists which offer these services - you can filter by choosing whether you want airbrush makeup, you want the artist to travel to your location as well as choose an artist for makeup for engagement, reception and wedding day as well. As a dulhan, makeup and hair services should be given utmost importance as they make or break your look in photos.";
        }
        if(category == "Bridal Wear"){
            cont = "The first thing that every bride thinks when the wedding date is fixed in the bridal lehenga or the bridal dress! Finding the perfect bridal wear is not only exciting but can get crazy too. Right from deciding your bridal lehenga to your bridesmaid’s dresses to what other wedding sarees are going to be like can literally be mind boggling! WedMeGood has the most amazing Pandora’s box to bridal wear! You can browse all your wedding outfits, latest lehenga looks, wedding gowns, best designer styles, celebrity styles right from home. Not only that, you can pick and shortlist your outfits or vendors by simply filtering by budget, outfit type or even store type. Right from the top end bridal wear designers in the country to the smallest bridal lehenga boutiques, it’s all right there for you. The wedding dress is of utmost importance in a wedding, however big or small – so you have to simply get the best!";
        }
        if(category == "Wedding Decorators"){
            cont = "However small or big your wedding is, your wedding decorations are a very vital part of the wedding celebrations. Right from zeroing in to the wedding theme to picking the centrepieces, every detail is important. That is why WedMeGood believes in getting you the best wedding decorators that provide more than just flower decorations for your dream wedding. You can browse through all the top wedding decorators, read their reviews, see their ratings from past clients and also browse through all the weddings they have done earlier to sense the style. Right from vendors who do wedding bouquets to tent decorators, all vendors are available a click away! You can also filter by the city and budget to shortlist your final vendors. ";
        }
        if(category == "Wedding Cakes"){
            cont = "No wedding celebration is complete without cutting a cake! Right from your bachelorette, engagement cake to your final wedding cakes and all the celebration cakes in between, we have the best list of wedding cake shops and bakers for you. Right from finding which is the top rated cake shop to what is the price per kg – all is available through a simple filter on WedMeGood. You can browse through the latest and best designs for all your wedding cakes and also shortlist your vendor right from home!";
        }
        if(category == "Wedding Jewellery" ){
            cont = "Indian bridal jewelry is one of the most important elements in a bridal outfit. Your bridal jewelry not only makes or breaks your wedding look, but also they are heirloom pieces that you pass on in your family. Our list of wedding jewellery designers can help you design your bridal jewelry sets as well as your other wedding jewelry sets. You can filter and browse through the latest real bridal jewelry, artificial bridal jewelry sets and also flower or gota bridal jewelry sets. Not only that, you can also filter by location and get whatever you want in any city on a click of a button. Right from your own bridal jewelry to jewelry for your bridesmaids, you can find it all. You can also find your bridal jewelry sets on rent at the most reasonable prices.";
        }
        if(category == "Groom Wear"){
            cont = "Groom wear has come a long way . From traditional Sherwanis to jodhpuri suits and other wedding suits- there are so many options for the new age groom to choose from. Some of the more trending groom wear ideas are Nehru Jackets on the mehendi to punjabi suits on the sangeet and wedding sherwanis that come in a range of colors- find your groom wear designer in our showcase";
        }
        if(category == "Wedding Planner "){
            cont = "WedMeGood is an Indian Wedding Planning Website and app where you can find the best wedding vendors, with prices and reviews at the click of a button. Whether you are looking to hire wedding planners in India, or looking for the top photographers, or just some ideas and inspiration for your wedding- WedMeGood can help you solve your wedding planning woes through its unique features. With a checklist, detailed vendor list , inspiration gallery and blog - you wont need to spend hours planning a wedding anymore";
        }
        if(category == "Wedding Cards"){
            cont = "Wedding cards set the tone for what to expect for your wedding so ensure that your invitation card incorporates your personality and the latest designs and ideas. Our invitation card showcase helps you find your wedding invitation by giving you a list of card makers who can make custom wedding invitations. You can browse their prices, view the best card makers by reading their reviews , and choose the best choice for your marriage .";
        }
        if(category == "Wedding Videography"){
            cont = "While photographers may be well known, wedding videpgraphers are the most upcoming trend in weddings. The best wedding videographers will use their cinematography skill to deliver your very own marriage video which is no less than your own wedding film. You can choose your videographer above by filtering through a list of the top names, with detailed prices.";
        }
        if(category == "Wedding Catering"){
            cont = "Food is an integral part of any Indian wedding, which is why your wedding catering and your wedding caterers have to be on point! Confused whether to select a caterer specialised in Chinese or Indian? Filter through our wedding caterers via price per plate and even via special requirements, like chaat, jain only and so on. This way the hassle of shortlisting who to book for your wedding catering services is diminished. You can find reviews and rating as well as contact numbers of all the top wedding caterers in whichever city you want. We believe that you should only get the best!";
        }
        if(category == "Trousseau Packers"){
            cont="Did you know that you can delegate your trousseau packing for weddings too? Creating a trousseau takes a huge amount of time and so does packing it! But now with trousseau packers you can forget all the worries and look forward to a beautifully packed trousseau to take to your new home. Right from saree packing, wedding gifts packing to marriage packing – wedding trousseau packers do it all. You can browse through the work of top trousseau packers, see their services, pick the latest designs and then finalise the best vendor you want for your wedding packing. Looking for someone to pack return gifts packing for wedding? There are trousseau packers for that too. Everything and everyone in the trousseau packing world are just a click away.";
        }
        if(category == "Sangeet Choreographers"){
            cont = "What is a wedding without any dance and music! Wedding choreographers and sangeet choreographers form a vital part of the sangeet night. You can find the perfect sangeet songs that are trending, choreography ideas and the best wedding dances that have happened in the year on our blog. Right from prices to finalizing the best wedding choreographer for your wedding dance, we will be there to plan it all for you. You can browse through vendors and their ratings through a simple and hassle-free filter. You can also draw inspiration for the bride and groom dance, ideas for the sangeet night, list of songs that you can do and a whole world of ideas right here!";
        }
        if(category == "DJ"){
            cont="We believe that the DJ for the wedding is the life of any wedding. Bad songs can not only bore your guests but also kill the wedding vibe. DJ for Sangeet and Mehendi DJ are equally important as those are the two functions where there is more dance and fun than any other function. Right from your bachelorette DJ to your DJ for the wedding, you can browse them in the DJ gallery. You can also find the prices, reviews, rating and all the contact information for the best DJs that will help you finalise your vendor.";
        }
        return cont;
    }
    function CategoryCityContent(category,city){
        var cont = 'Browse, compare and select the best '+category+' in '+city+' at WedMeGood. Check their prices & availability and book your date now. See their photos, videos and reviews for '+city+' '+category+'. Send enquiry and ask for the best prices for your wedding. Get contact details & more info about the vendor.';

        if(category == "Wedding Photographers"){
            cont = "Finding a wedding photographer in "+city+" is no easy task. Whether it is for a pre wedding shoot, your bridal photos, candid wedding photography or traditional photography there are a host of options on WedMeGood for photographers in "+city+". Choose from top wedding photographers, see their wedding pictures in their portfolio, filter by price and reviews to hire the best photographers for your indian wedding. Your engagement pictures and wedding photos need to be preserved, so ensure a professional photographer from "+city+" is hired instead of choosing anyone.";
        }

        if(category == "Bridal Makeup"){
            cont = "Are you trying to find the best bridal makeup in "+city+"? WedMeGood has a list of best makeup artists for indian brides, who will give you options for wedding hairstyles, customise as per bridal package and advise you on the best bridal makeup styles that look great in pictures. Whether you need an airbrush makeup artist in "+city+" or need makeup for your engagement, reception or wedding day, or you need an airbrush makeup artist in "+city+", or need makeup for your engagement, reception or wedding day, choose an artist or salon that can provide both hair and makeup services along with draping so that you can look your stunning best in wedding photos.";
        }
        if(category == "Bridal Wear"){
            cont = "Scouting for the perfect wedding lehenga is no easy task, especially when you are in "+city+"! Whether it is your bridal lehenga, wedding gown or your bridesmaid’s dresses, hunting all your outfits in one go is daunting. But now on WedMeGood you can do that by simply filtering the city that you wish to pick your bridal wear from, the budget you are looking at, the outfit style and even the store type. Right from the top end designers in "+city+" to the smallest bridal lehenga boutiques, it’s all right there for you. So you can shortlist your wedding saree from Jaipur, bridal lehenga from Chandni Chowk in Delhi and engagement outfit from Mumbai on WedMeGood itself!";
        }
        if(category == "Wedding Decorators"){
            cont = "Having a wedding in "+city+" and going mad finding the perfect wedding decorator? Now you can simply browse through all the top wedding decorators, read their reviews, see their ratings from past clients and also browse through all the weddings they have done earlier to sense the style. Right from vendors who do wedding bouquets to tent houses, all vendors are available a click away! You can also filter by the city and budget to shortlist your wedding decorator in "+city+" for customized decorations as per your choice. ";
        }
        if(category == "Wedding Cakes"){
            cont = "When you are in "+city+", selecting the best wedding cake can be a problem since there are so many options! No wedding celebration is complete without cutting a cake! Right from your bachelorette, engagement cake to your final wedding cakes and all the celebration cakes in between, we have the best list of wedding cake shops and bakers in "+city+" for you. Right from finding which is the top rated cake shop in "+city+" and to what is the price per kg – all is available through a simple filter on WedMeGood. You can browse through the latest designs and choose the best wedding cake and also shortlist your vendor in "+city+" right from home! ";
        }
        if(category == "Wedding Jewellery" ){
            cont = "Finding the perfect Indian bridal jewelry can get crazy, especially in "+city+" where you have a range of options! Indian bridal jewelry is one of the most important elements in a bridal outfit. Your bridal jewelry not only makes or breaks your wedding look, but also they are heirloom pieces that you pass on in your family. At WedMeGood, find a list jewellery designers in "+city+" that can help you design your bridal jewelry sets as well as your other wedding jewelry sets. You can filter and browse through the latest real bridal jewelry, artificial bridal jewelry sets and also flower or gota bridal jewelry sets. Right from your own bridal jewelry to jewelry for your bridesmaids, you can find it all. If you want to save on your jewelry thing, you can also get bridal jewelry sets on rent in "+city+" at the most reasonable prices.";
        }
        if(category == "Groom Wear"){
            cont = "Groom wear in "+city+" has come a long way. From traditional Sherwanis to jodhpuri suits and other wedding suit designers - there are so many options in "+city+" for the new age groom to choose from. You can find a list of Groom wear designers in "+city+" here, see their collection, check their reviews, shortlist the best wedding suit designers in "+city+" and get their store location. ";
        }
        if(category == "Wedding Planner "){
            cont = "Getting married in "+city+"? Need a wedding planner to plan your wedding in your budget and as per your choice? Find a list of best wedding planners in "+city+" here. Check their prices & reviews and select the right wedding planner in "+city+" for you. You can also have a look at their work through photos & videos, check their availability, shortlist them, get contact details, send enquiry and get best quote directly from the vendor. ";
        }
        if(category == "Wedding Cards"){
            cont = " Our "+city+" invitation card showcase helps you find your wedding invitation by giving you a list of card makers in "+city+" who can make custom wedding invitations. The wedding card makes the first impression. So, have a look at the wedding card designs, browse their prices, view the best card makers by reading their reviews, and choose the best choice for your marriage invitation.  ";
        }
        if(category == "Wedding Videography"){
            cont = "Find your wedding videographer in "+city+" on WedMeGood . You can find the best wedding videographers in "+city+" by going through our detailed list with prices, filter by top reviews and ensure your marriage video is the most beautiful one by making the right choice.";
        }
        if(category == "Wedding Catering"){
            cont = "Selection of the best wedding caterer in "+city+" is almost impossible without any help! Food is an integral part of any Indian wedding, which is why your wedding catering and your wedding caterers have to be on point! Filter through our wedding caterers via price per plate and even via special requirements, like chaat, jain only and so on. This way the hassle of shortlisting the best wedding catering service is diminished. You can find reviews and rating as well as contact numbers of all the top wedding caterers in "+city+".";
        }
        if(category == "Trousseau Packers"){
            cont="Looking for trousseau packing vendors in "+city+"? We have them right here! Creating a trousseau takes a huge amount of time and so does packing it. But now with this comprehensive list of trousseau packers in "+city+" along with a showcase of their work and prices, you can forget all the worries and look forward to a beautifully packed trousseau to take to your new home. You can browse through the work of top trousseau packers, see their services, pick the latest designs and then finalise the best vendor you want for your wedding packing. Looking for someone to pack return gifts packing for wedding? There are trousseau packers for that too. ";
        }
        if(category == "Sangeet Choreographers"){
            cont = "When wedding is coming, performance at sangeet and wedding is the most sought after thing for the bride and bridesmaid!  If you are in search for a good wedding & sangeet choreographer, choose from our list of Chorepgraphers in "+city+" specialised in a bunch of things- right from Bhangra to new age contemporary dances and full on Bollywood choreography.  You can select the best for you by seeing at the prices, checking their videos and reading reviews here. You can browse through choreographers via location and their ratings through a simple and hassle-free filter. You can also draw inspiration for the bride and groom dance, ideas for the sangeet night, list of songs that you can do and a whole world of ideas from our Inspriation section.";
        }
        if(category == "DJ"){
            cont="Hunting the best DJ in "+city+"? Your answer is right here. We believe that the DJ for the wedding is the life of any wedding. DJ for Sangeet and Mehendi DJ are equally important as those are the two functions where there is more dance and fun than any other function. Right from your bachelorette DJ to your DJ for the wedding, you can browse them in the DJ gallery. You can also find the prices, reviews, rating and all the contact information for the best DJs in "+city+" that will help you finalise your vendor.";
        }
        return cont;
    }

    function CityVenueContent(str){
        var cont = 'Weddings in '+str+' are a big affair and planning a wedding starts at the wedding venue. So how do you go about booking the best venue in '+str+' for you ? Start by deciding whether you would like an indoor wedding or an outdoor one. Depending on this, choose from either top banquet halls, marriage lawns, lush green farmhouses near '+str+', or just intimate garden party venues for a small gathering using our filters above. Next filter by price per plate so you can make a selection from luxury hotels, or budget marriage halls. Also keep in mind the function you are having - a top wedding venue may not be perfect for receptions and vice versa. Last but definitely not the least - pick an area in '+str+' most convenient to you. ';
        return cont;
    }

    function VenueProfileContent(vendor,city,locality){
        var cont = 'Get best quote from '+vendor+' and book your date! Send enquiry to your selected list of venues at WedMeGood and choose the best banquet hall, marriage lawn, 5 star hotel, resort or a poolside / terrace venue for your wedding. Browse for more venues in '+locality+' '+city+' and more wedding vendors in your '+city+' at WedMeGood and plan your wedding hassle free.';
        return cont;
    }

    function VendorProfileContent(vendor,city,category){
        var cont = 'Get best quote from '+vendor+' and book your date! Check their prices and availability. Send enquiry to your selected list of '+category+' at WedMeGood and choose the best. Browse for more '+category+' in '+city+' and more wedding vendors at WedMeGood and plan your wedding hassle free.';
        return cont;
    }

    function CityVenueLocalityContent(city,locality){
        var cont = "Looking for the best wedding venues in "+locality+", "+city+"? Well, you've come to the right place. First of all, decide whether you would like to book a banquet hall in "+locality+" or a farmhouse in "+locality+" . This choice is really dependent on your preferences of an outdoor or indoor wedding as well as the weather at the time of your wedding. Next, choose from a variety of luxury, 5 star, 4 star, 3 star and budget venue options in "+locality+" by using our price per plate filter to choose according to your budget. Finally, book the venue or marriage hall of your choice by looking at their reviews and ratings.";
        return cont;
    }

    function toTitleCase(str)
    {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    function init(){

        var link =  window.location.pathname;
//**********************To generate category city specific content****************************
        if(location.pathname == '/'){
            $scope.content = "WedMeGood is an Indian Wedding Planning Website and app where you can find the best wedding vendors, with prices and reviews at the click of a button. Whether you are looking to hire wedding planners in India, or looking for the top photographers, or just some ideas and inspiration for your wedding. WedMeGood can help you solve your wedding planning woes through its unique features. With a checklist, detailed vendor list, inspiration gallery and blog - you wont need to spend hours planning a wedding anymore.";
        }

        if(link.search('vendor')!=-1){

            var link_split = link.split("/");
            if(link_split[2]!="")
                var city_slug  = link_split[2];
            if(link_split[3]!="")
                var category_slug = link_split[3];
            if(link_split[4] != "")
                var locality_slug = link_split[4];

            if(city_slug != undefined && category_slug != undefined){
                if(category_slug == "wedding-venues"){
                    var city = getCity(city_slug);
                    if(city_slug == "all"){
                        $scope.content = "Finding a wedding venue can be a hard task. Whether you are looking for a venue in Delhi, Bombay, Bangalore, Hyderabad or any other Indian city , this is where your wedding planning starts. First off, start with figuring out whether you would like an indoor wedding or an outdoor one. Depending on this, choose from some of the best banquet halls, farmhouses or just garden party venues using our filters above. Next depending on whether you are having a luxury or a budget conscious wedding, choose a marriage hall with the appropriate price per plate from the given choices . Of course - don't forget the event- reception venues may require different criteria than Mehendi venues for example. You can also use reviews and ratings of the venues provided to shortlist further . If you are looking at destination weddings and beach weddings however, you may have to book venue packages instead of per plate pricing.";
                    }else{
                        if(locality_slug!=undefined){
                            locality_slug = locality_slug.replace("-"," ");
                            locality_slug = toTitleCase(locality_slug);
                            $scope.content = CityVenueLocalityContent(city,locality_slug);

                        }
                        else
                            $scope.content = CityVenueContent(city);
                    }
                }else{
                    var category = getCategory(category_slug);
                    var city = getCity(city_slug);
                    if(city_slug == "all"){
                        $scope.content = CategoryContent(category);
                    }else{
                            $scope.content = CategoryCityContent(category,city);
                    }
                }
            }
        }

//************************************************************77************************
//**********************To generate Profile specific content****************************
        if(link.search('profile') != -1){
            $scope.vendorName = "";
            $scope.city="";
            $scope.locality="";
            $scope.category = "";
            $('#header').on('SendVendorDetail',function(event,data){
            $scope.$apply(function() {
                $scope.vendorName = data.profile.name;
                $scope.city= data.profile.city;
                $scope.locality= data.profile.locality_name;
                $scope.category = data.profile.category_name;

            if($scope.category == "Venue")
                $scope.content = VenueProfileContent($scope.vendorName,$scope.city,$scope.locality);
            else
                $scope.content = VendorProfileContent($scope.vendorName,$scope.city,$scope.category);

            });
            });
        }

//******************************************I don't whats wrong but these people want this to be a logic***********************//
        if(link.search('wedding-photographers') != -1){
            $scope.showVenue = false;
            $scope.showPhotographers = true;
        }
        if(link.search('bridal-makeup') != -1){
            $scope.showVenue = false;
            $scope.showBridalMakeups = true;
        }
        if(link.search('bridal-wear') != -1){
            $scope.showVenue = false;
            $scope.showBridalWear = true;
        }
        if(link.search('groom-wear') != -1){
            $scope.showVenue = false;
            $scope.showGroomWear = true;
        }
        if(link.search('wedding-decorators') != -1){
            $scope.showVenue = false;
            $scope.showTent = true;
        }
        if(link.search('wedding-cards') != -1){
            $scope.showVenue = false;
            $scope.showInvitations = true;
        }
        if(link.search('wedding-favors') != -1){
            $scope.showVenue = false;
            $scope.showFavour = true;
        }
        if(link.search('delhi-ncr') != -1){
            $scope.currentCity = false;
            $scope.currentCityDelhi = true;
        }
        if(link.search('mumbai') != -1){
            $scope.currentCity = false;
            $scope.currentCityMumbai = true;
        }
    }

}]);

angular.bootstrap(document.getElementById("footerApp"), ['footerApp']);
